module.exports = __webpack_public_path__ + "static/media/document.357329b6.svg";